/* Built In Imports */
import NextLink from 'next/link';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Divider, Flex, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import NoData from '@components/Utility/NoData';

/* Services */

/**
 * Renders the AllTopics component
 * @param {Object} topics
 * @param {Boolean} isOverlay
 * @param {string} urlpath
 * @returns {ReactElement} AllTopics component
 */
export default function AllTopics({ topics, isOverlay = false, urlpath }) {
  const [allTopics, setAllTopics] = useState([]);
  const [allTopicsQuotes, setAllTopicsQuotes] = useState([]);

  useEffect(() => {
    if (topics) {
      const allTopics = topics[0].allTopics;
      const allTopicsQuotes = topics[1].allTopicsQuotes;
      if (allTopics && allTopics.length > 0) {
        let alltopicsWithAlpha = getAlphabetArr(allTopics);
        setAllTopics(alltopicsWithAlpha);
      }
      if (allTopicsQuotes && allTopicsQuotes.length > 0) {
        let topicsWithAlphabet = getAlphabetArr(allTopicsQuotes);
        setAllTopicsQuotes(topicsWithAlphabet);
      }
    }
  }, [topics]);

  function getAlphabetArr(arr) {
    return arr
      .map(el => {
        if (!Number(el.title.charAt(0))) {
          return { ...el, alphabet: el.title.charAt(0) };
        }
        return el;
      })
      .filter(el => el.alphabet);
  }

  function renderContent(topicsList, headerText) {
    if (topicsList && topicsList.length > 0) {
      return <>
        <Box
          w="100%"
          float="left"
          textAlign="center"
          fontFamily="FedraSansStd-A-medium"
          color="#28231e"
          pb="6px"
          fontWeight="500"
          fontSize="30px"
          mt="77px"
        >
          {headerText}
        </Box>
        <Box pos="relative" w="100%">
          <Flex
            flexWrap="wrap"
            justifyContent="space-between"
            w={{ base: '96%', lg: '100%' }}
            m="0 auto"
          >
            {topicsList.map((mainTopic, i) => (
              <>
                {topicsList[i - 1] &&
                topicsList[i - 1].alphabet &&
                topicsList[i - 1].alphabet === mainTopic.alphabet ? null : (
                  <>
                    <Box
                      key={i}
                      w={{
                        base: '100%',
                        md: '25%',
                      }}
                      mb={{
                        base: 'unset',
                        lg: '50px',
                      }}
                    >
                      <Divider mt="20px" mb={{ base: '38px', lg: '20px' }} />
                      <Text
                        w="100%"
                        fontSize="36px"
                        color="#262626"
                        float="left"
                        textAlign="left"
                        fontFamily="FedraSansStd-A-medium"
                        pl="0"
                        mb={{ base: '17px', lg: '0' }}
                      >
                        {mainTopic.alphabet}
                      </Text>
                      {topicsList.map((subtopic, index) => {
                        return mainTopic.alphabet === subtopic.alphabet ? (
                          <Text>
                            <NextLink
                              href={
                                isOverlay
                                  ? `${urlpath}?topic=${
                                      /[^/]*$/.exec(subtopic.url)[0]
                                    }`
                                  : subtopic.url
                              }
                              passHref
                              prefetch={false}
                              legacyBehavior>
                              <Link>
                                <Box
                                  key={index}
                                  w={{ base: '90%', lg: '100%' }}
                                  float="left"
                                  textAlign="left"
                                  fontFamily="FedraSansStd-book"
                                  fontSize="18px"
                                  color="#28231e"
                                  lineHeight="24px"
                                  pb="16px"
                                  textDecoration="none"
                                  display="inline"
                                  cursor="pointer"
                                >
                                  {subtopic.title}
                                </Box>
                              </Link>
                            </NextLink>
                          </Text>
                        ) : null;
                      })}
                    </Box>
                  </>
                )}
              </>
            ))}
            {topicsList.length % 4 === 0 ? null : (
              <Box
                display={{ base: 'none', md: 'block', lg: 'block' }}
                flexGrow="10"
                w={{
                  base: '100%',
                  md: '25%',
                }}
                mb={{
                  base: 'unset',
                  lg: '50px',
                }}
              >
                <Divider mt="20px" mb="40px" />
              </Box>
            )}
          </Flex>
        </Box>
      </>;
    }
    return null;
  }

  return topics?.length ? (
    <Box
      pos="relative"
      float="left"
      w={{
        base: '100%',
        lg: '60%',
      }}
      p="12px"
    >
      {renderContent(allTopics, 'All Topics')}
      {renderContent(allTopicsQuotes, 'All Topics for Quotes')}
    </Box>
  ) : (
    <NoData />
  );
}
